(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cozy-club"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Cozy Club — Klaviyo

     Posts straight to Klaviyo's client subscription endpoint so
     the markup stays ours. Klaviyo's embedded forms bring their
     own stylesheet and reset it on every template update, which
     is a losing fight against a designed section.

     Client endpoints take the public key only. Never a private
     key: this runs in the browser where anyone can read it.
     ========================================================== */

  (function () {
    'use strict';

    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var REVISION = '2026-07-15';
    var FLAG = 'ccInit';

    function init(root) {
      var forms = (root || document).querySelectorAll('[data-cc-form]');

      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        if (form.dataset[FLAG] === 'true') continue;
        form.dataset[FLAG] = 'true';

        if (form.getAttribute('data-provider') !== 'klaviyo') continue;

        var key = form.getAttribute('data-klaviyo-key');
        var list = form.getAttribute('data-klaviyo-list');

        // Without both, the Shopify form is left to submit as
        // usual rather than silently swallowing signups.
        if (!key || !list) continue;

        bind(form, key, list);
      }
    }

    function bind(form, key, list) {
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');
      var message = form.querySelector('[data-cc-message]');
      if (!input) return;

      form.setAttribute('novalidate', '');

      function say(text, ok) {
        if (!message) return;
        message.textContent = text;
        message.hidden = false;
        message.classList.toggle('cc__note--error', !ok);
      }

      var twoStep = form.getAttribute('data-steps') === 'email_then_sms';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var email = (input.value || '').trim();
        if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
          say(form.getAttribute('data-msg-invalid') || 'Please enter a valid email address.', false);
          input.focus();
          return;
        }

        if (button) button.disabled = true;
        say(form.getAttribute('data-msg-sending') || 'One moment...', true);

        fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: REVISION
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: {
                        email: { marketing: { consent: 'SUBSCRIBED' } }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: list } }
              }
            }
          })
        })
          .then(function (r) {
            // The endpoint answers 202: accepted and processed
            // afterwards, so there is nothing more to wait for.
            if (r.status === 202 || r.ok) {
              form.reset();
              say(form.getAttribute('data-msg-success') || "You're in. Check your inbox.", true);
              if (twoStep) revealStep2(form, key, email);
            } else {
              say(form.getAttribute('data-msg-error') || 'Something went wrong. Please try again.', false);
            }
          })
          .catch(function () {
            say(form.getAttribute('data-msg-error') || 'Something went wrong. Please try again.', false);
          })
          .then(function () {
            if (button) button.disabled = false;
          });
      });
    }

    /* ── step two ─────────────────────────────────────────── */

    /* Klaviyo needs E.164, so a typed number is normalised
       before sending. Anything already starting with + is left
       alone; ten digits get the section's country code. */
    function toE164(raw, country) {
      var digits = (raw || '').replace(/[^\d+]/g, '');
      if (digits.charAt(0) === '+') return digits;
      digits = digits.replace(/\D/g, '');
      if (!digits) return '';
      var cc = (country || '+1').replace(/\D/g, '');
      if (digits.length > 10 && digits.indexOf(cc) === 0) return '+' + digits;
      return '+' + cc + digits;
    }

    function revealStep2(form, key, email) {
      var section = form.closest('.cc') || document;
      var panel = section.querySelector('[data-cc-step2]');
      if (!panel) return;

      panel.hidden = false;

      var phone = panel.querySelector('[data-cc-phone]');
      var button = panel.querySelector('[data-cc-phone-submit]');
      var message = panel.querySelector('[data-cc-phone-message]');
      var skip = panel.querySelector('[data-cc-skip]');
      if (!phone || !button) return;

      // Moving focus here is what makes the second step feel like
      // a continuation rather than something that just appeared.
      phone.focus();

      var list = form.getAttribute('data-sms-list') || form.getAttribute('data-klaviyo-list');
      var country = form.getAttribute('data-country') || '+1';

      function say(text, ok) {
        if (!message) return;
        message.textContent = text;
        message.hidden = false;
        message.classList.toggle('cc__note--error', !ok);
      }

      if (skip) {
        skip.addEventListener('click', function () {
          panel.hidden = true;
        });
      }

      button.addEventListener('click', function () {
        var e164 = toE164(phone.value, country);

        if (e164.length < 11) {
          say(panel.getAttribute('data-msg-invalid') || 'Please enter a valid phone number.', false);
          phone.focus();
          return;
        }

        button.disabled = true;
        say(panel.getAttribute('data-msg-sending') || 'One moment...', true);

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      // The email ties this to the profile made a
                      // moment ago rather than creating a second.
                      email: email,
                      phone_number: e164,
                      subscriptions: {
                        sms: { marketing: { consent: 'SUBSCRIBED' } }
                      }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        })
          .then(function (r) {
            if (r.status === 202 || r.ok) {
              phone.value = '';
              say(panel.getAttribute('data-msg-success') || "Done. Keep an eye on your messages.", true);
              phone.disabled = true;
              button.disabled = true;
              if (skip) skip.hidden = true;
              return;
            }
            say(panel.getAttribute('data-msg-error') || 'Something went wrong. Please try again.', false);
            button.disabled = false;
          })
          .catch(function () {
            say(panel.getAttribute('data-msg-error') || 'Something went wrong. Please try again.', false);
            button.disabled = false;
          });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Feature

     Hovering a scent in the contents list takes the section over
     in that scent's colour. The type colour is computed in
     Liquid from the scent's own brightness, so the swap can
     never land dark type on a dark ground.
     ========================================================== */

  (function () {
    'use strict';

    var FLAG = 'featureInit';

    function init(root) {
      var scope = root || document;
      var nodes = scope.querySelectorAll('[data-feature]');

      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset[FLAG] === 'true') continue;
        el.dataset[FLAG] = 'true';
        if (el.getAttribute('data-hover-colour') === 'true') hoverColour(el);
      }
    }

    function hoverColour(el) {
      var rows = el.querySelectorAll('[data-row-color]');
      if (!rows.length) return;

      // Pointer only. On touch there is no hover, and firing this
      // on tap would flash the section on the way to the PDP.
      if (!window.matchMedia('(hover: hover)').matches) return;

      // The button reads the theme's own colour variables, which
      // take RGB triplets rather than hex, so the swap converts.
      function rgb(hex) {
        var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec((hex || '').trim());
        if (!m) return null;
        return parseInt(m[1], 16) + ' ' + parseInt(m[2], 16) + ' ' + parseInt(m[3], 16);
      }

      function apply(colour, type) {
        el.style.setProperty('--ft-bg', colour);
        el.style.setProperty('--ft-fg', type);

        // Keep the button legible against whatever just arrived.
        var bg = rgb(type);
        var fg = rgb(colour);
        if (!bg || !fg) return;

        el.style.setProperty('--button-color-background', bg);
        el.style.setProperty('--button-color-text', fg);
        el.style.setProperty('--button-color-border', bg);
        el.style.setProperty('--button-color-background-hover', bg);
        el.style.setProperty('--button-color-text-hover', fg);
        el.style.setProperty('--button-color-border-hover', bg);
      }

      function clear() {
        [
          '--ft-bg',
          '--ft-fg',
          '--button-color-background',
          '--button-color-text',
          '--button-color-border',
          '--button-color-background-hover',
          '--button-color-text-hover',
          '--button-color-border-hover'
        ].forEach(function (name) {
          el.style.removeProperty(name);
        });
      }

      rows.forEach(function (row) {
        var colour = row.getAttribute('data-row-color');
        var type = row.getAttribute('data-row-type');
        if (!colour) return;

        row.addEventListener('mouseenter', function () { apply(colour, type); });
        row.addEventListener('focusin', function () { apply(colour, type); });
      });

      // Cleared on leaving the list rather than each row, so
      // moving between rows does not flash back to the base.
      var list = rows[0].closest('.ft__spec') || el;
      list.addEventListener('mouseleave', clear);
      list.addEventListener('focusout', function (e) {
        if (!list.contains(e.relatedTarget)) clear();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Hero slideshow

     Runs only when there is more than one slide. Autoplay is off
     under reduced motion, pauses on hover and keyboard focus,
     and stops for good once a visitor picks a slide.
     ========================================================== */

  (function () {
    'use strict';

    var FLAG = 'heroInit';

    function init(root) {
      var scope = root || document;
      var heroes = scope.querySelectorAll('[data-hero]');

      for (var i = 0; i < heroes.length; i++) {
        var el = heroes[i];
        if (el.dataset[FLAG] === 'true') continue;
        el.dataset[FLAG] = 'true';

        // Runs whether or not there is a slideshow: a single
        // slide never instantiates Hero, and its video needs the
        // same nudge.
        nudge(el.querySelector('[data-hero-slide].is-active'));

        if (el.querySelectorAll('[data-hero-slide]').length > 1) new Hero(el);
      }
    }

    function Hero(el) {
      this.el = el;
      this.slides = Array.prototype.slice.call(el.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.prototype.slice.call(el.querySelectorAll('[data-hero-dot]'));
      this.controlsEl = el.querySelector('.hero__controls');
      this.status = el.querySelector('[data-hero-status]');
      this.total = this.slides.length;
      this.index = 0;
      this.timer = null;
      this.stopped = false;

      this.autoplay =
        el.getAttribute('data-autoplay') === 'true' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = (parseInt(el.getAttribute('data-interval'), 10) || 6) * 1000;

      this.bind();
      this.matchControls(0);
      this.playActive(0);
      if (this.autoplay) this.start();
    }

    Hero.prototype.bind = function () {
      var self = this;

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.stop();
          self.go(parseInt(dot.getAttribute('data-hero-dot'), 10) || 0);
        });
      });

      var prev = this.el.querySelector('[data-hero-prev]');
      var next = this.el.querySelector('[data-hero-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          self.stop();
          self.go(self.index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          self.stop();
          self.go(self.index + 1);
        });
      }

      // Paused while someone is reading or tabbing through.
      this.el.addEventListener('mouseenter', function () { self.pause(); });
      this.el.addEventListener('mouseleave', function () { self.resume(); });
      this.el.addEventListener('focusin', function () { self.pause(); });
      this.el.addEventListener('focusout', function () { self.resume(); });

      this.el.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          self.stop();
          self.go(self.index - 1);
        } else if (e.key === 'ArrowRight') {
          self.stop();
          self.go(self.index + 1);
        }
      });

      // Never animate against a hidden tab.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { self.pause(); } else { self.resume(); }
      });

      this.bindSwipe();
    };

    /* Swipe on touch. Deliberately not a horizontal scroller:
       the slides are stacked and crossfade, so the gesture is
       read directly.

       The vertical check matters. Without it a diagonal flick
       while scrolling the page changes the slide, which feels
       like the site misfiring. */
    Hero.prototype.bindSwipe = function () {
      var el = this.el;
      var self = this;
      var startX = 0;
      var startY = 0;
      var startT = 0;
      var tracking = false;

      var MIN_DISTANCE = 45;
      var MAX_OFF_AXIS = 0.6;
      var MAX_TIME = 700;

      el.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length !== 1) return;
          tracking = true;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          startT = Date.now();
        },
        { passive: true }
      );

      el.addEventListener(
        'touchend',
        function (e) {
          if (!tracking) return;
          tracking = false;

          var touch = e.changedTouches[0];
          if (!touch) return;

          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;

          if (Date.now() - startT > MAX_TIME) return;
          if (Math.abs(dx) < MIN_DISTANCE) return;
          // Mostly vertical: the visitor is scrolling the page.
          if (Math.abs(dy) > Math.abs(dx) * MAX_OFF_AXIS) return;

          self.stop();
          self.go(dx < 0 ? self.index + 1 : self.index - 1);
        },
        { passive: true }
      );

      // A cancelled touch is a scroll the browser took over.
      el.addEventListener(
        'touchcancel',
        function () {
          tracking = false;
        },
        { passive: true }
      );
    };

    /* Autoplay refusals are common and have several causes, so
       this keeps trying rather than making one attempt.

       The muted property matters most: Safari checks the
       property, not the attribute in the markup, so a video that
       looks muted in the HTML can still be refused. Setting it
       in script before calling play is the documented fix.

       Everything stops the moment the video is actually playing,
       so none of this runs longer than it has to. */
    function nudge(slide) {
      if (!slide) return;
      var video = slide.querySelector('video');
      if (!video) return;
      if (video.dataset.nudging === 'true') return;
      video.dataset.nudging = 'true';

      // Property, not just the attribute.
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      var tries = 0;
      var timer = null;
      var io = null;

      function done() {
        video.dataset.nudging = 'false';
        window.clearInterval(timer);
        document.removeEventListener('touchstart', onGesture);
        document.removeEventListener('click', onGesture);
        document.removeEventListener('scroll', onGesture);
        document.removeEventListener('keydown', onGesture);
        document.removeEventListener('visibilitychange', attempt);
        window.removeEventListener('load', attempt);
        if (io) io.disconnect();
      }

      function attempt() {
        if (!video.paused) return done();

        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.then(done).catch(function () {
            // Refused. One of the listeners below will try again.
          });
        }
      }

      function onGesture() {
        attempt();
      }

      attempt();

      // Called before the file has data, which rejects on its own
      // terms rather than for policy reasons.
      video.addEventListener('loadeddata', attempt);
      video.addEventListener('canplay', attempt);
      window.addEventListener('load', attempt);
      document.addEventListener('visibilitychange', attempt);

      // Gesture listeners stay attached until it plays. The
      // earlier version removed them after one try, so a single
      // refusal left the video paused for good.
      document.addEventListener('touchstart', onGesture, { passive: true });
      document.addEventListener('click', onGesture);
      document.addEventListener('scroll', onGesture, { passive: true });
      document.addEventListener('keydown', onGesture);

      // Some browsers refuse while the element is off screen.
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) attempt();
        });
        io.observe(video);
      }

      // A short poll covers the cases none of the events above
      // announce. Ten tries over five seconds, then it stops.
      timer = window.setInterval(function () {
        tries += 1;
        if (tries > 10 || !video.paused) return done();
        attempt();
      }, 500);
    }

    /* Off-screen videos are paused: a slideshow decoding several
       at once is wasted battery. */
    Hero.prototype.playActive = function (i) {
      this.slides.forEach(function (slide, k) {
        var video = slide.querySelector('video');
        if (!video) return;

        if (k === i) {
          nudge(slide);
        } else if (!video.paused) {
          video.pause();
        }
      });
    };

    Hero.prototype.go = function (n) {
      var i = ((n % this.total) + this.total) % this.total;
      if (i === this.index) return;
      this.index = i;

      this.slides.forEach(function (slide, k) {
        var on = k === i;
        slide.classList.toggle('is-active', on);
        if (on) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      this.dots.forEach(function (dot, k) {
        dot.classList.toggle('is-active', k === i);
      });

      this.matchControls(i);
      this.playActive(i);

      if (this.status) {
        this.status.textContent = 'Slide ' + (i + 1) + ' of ' + this.total;
      }
    };

    /* Controls sit outside the slides, so they cannot inherit the
       slide's colour. Read it off the active slide and hand it to
       the cluster, otherwise white controls vanish on a slide with
       dark text over pale imagery. */
    Hero.prototype.matchControls = function (i) {
      if (!this.controlsEl) return;
      var slide = this.slides[i];
      if (!slide) return;

      var fg = getComputedStyle(slide).getPropertyValue('--slide-fg').trim();
      if (fg) this.controlsEl.style.setProperty('--hero-controls', fg);
    };

    Hero.prototype.start = function () {
      var self = this;
      if (this.timer || this.stopped) return;
      this.timer = window.setInterval(function () {
        self.go(self.index + 1);
      }, this.interval);
    };

    Hero.prototype.pause = function () {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    };

    Hero.prototype.resume = function () {
      if (this.autoplay && !this.stopped) this.start();
    };

    // Someone who clicked a control has chosen a slide. Taking it
    // away a few seconds later is hostile.
    Hero.prototype.stop = function () {
      this.stopped = true;
      this.pause();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });

    // Theme editor: show the slide being edited.
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('[data-hero-slide]') : null;
      if (!slide) return;
      var hero = slide.closest('[data-hero]');
      if (!hero) return;

      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      var dots = hero.querySelectorAll('[data-hero-dot]');
      var i = slides.indexOf(slide);

      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        if (k === i) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      Array.prototype.forEach.call(dots, function (d, k) {
        d.classList.toggle('is-active', k === i);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["note-wall"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Note Wall

     One job: fade tiles in as the wall enters the viewport,
     staggered by column so it reads as a wave rather than a
     block. Everything else is CSS.
     ========================================================== */

  (function () {
    'use strict';

    var FLAG = 'noteWallInit';

    function init(root) {
      var scope = root || document;
      var walls = scope.querySelectorAll('[data-note-wall]');

      for (var i = 0; i < walls.length; i++) {
        var wall = walls[i];
        if (wall.dataset[FLAG] === 'true') continue;
        wall.dataset[FLAG] = 'true';

        initFilter(wall);

        if (
          wall.getAttribute('data-reveal-on') !== 'true' ||
          !('IntersectionObserver' in window) ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          wall.setAttribute('data-reveal', 'false');
          continue;
        }

        wall.setAttribute('data-reveal', 'true');
        observe(wall);
      }
    }

    /* ── family filter ────────────────────────────────────── */

    function initFilter(wall) {
      var bar = wall.querySelector('[data-nw-filters]');
      if (!bar) return;

      var buttons = bar.querySelectorAll('[data-nw-filter]');
      var items = wall.querySelectorAll('[data-nw-item]');
      var status = wall.querySelector('[data-nw-status]');
      var mode = wall.getAttribute('data-filter-mode') || 'dim';

      // Revealed only once JS is running, so a no-JS visitor
      // never sees a control that cannot do anything.
      bar.removeAttribute('hidden');

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.getAttribute('data-nw-filter');
          var shown = 0;

          buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
          });

          items.forEach(function (item) {
            var raw = item.getAttribute('data-families') || '';
            // Comma delimited from Liquid, but whitespace is
            // accepted too so a hand-edited value still works.
            var tokens = raw
              .toLowerCase()
              .split(/[\s,]+/)
              .filter(function (t) {
                return t.length > 0;
              });

            var match = value === '*' || tokens.indexOf(value.toLowerCase()) > -1;

            if (match) shown++;

            if (mode === 'hide') {
              if (match) {
                item.removeAttribute('hidden');
              } else {
                item.setAttribute('hidden', '');
              }
            } else {
              item.classList.toggle('is-muted', !match);
            }
          });

          if (status) {
            status.textContent =
              shown + (shown === 1 ? ' note shown' : ' notes shown');
          }
        });
      });
    }

    function observe(wall) {
      var items = wall.querySelectorAll('.nw__item');
      var cols =
        parseInt(
          getComputedStyle(wall).getPropertyValue('--nw-cols'),
          10
        ) || 8;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            var el = entry.target;
            // Stagger across the row, so a wall of forty does not
            // arrive as one slab.
            var delay = (el.dataset.col % cols) * 45;
            el.style.transitionDelay = delay + 'ms';
            el.classList.add('is-in');
            io.unobserve(el);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );

      for (var i = 0; i < items.length; i++) {
        items[i].dataset.col = i;
        io.observe(items[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-section"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Press

     One quote track drives both breakpoints. Mobile: native
     swipe + dots, synced via IntersectionObserver. Desktop:
     hovering a logo scrolls the track to that publication's
     slide (no visible scrollbar/dots there). Logos keep their
     own href — nothing here touches their click behaviour.
     ========================================================== */

  (function () {
    'use strict';

    var FLAG = 'pressInit';

    function init(root) {
      var scope = root || document;
      var nodes = scope.querySelectorAll('[data-press]');

      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset[FLAG] === 'true') continue;
        el.dataset[FLAG] = 'true';
        initCarousel(el);
      }
    }

    function initCarousel(el) {
      var carousel = el.querySelector('[data-quote-carousel]');
      if (!carousel) return;

      var track = carousel.querySelector('[data-quote-track]');
      var dots = carousel.querySelectorAll('[data-quote-dot]');
      if (!track || !track.children.length) return;

      var slides = Array.prototype.slice.call(track.children);

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function goTo(index, smooth) {
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({
          left: slide.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto'
        });
        setActiveDot(index);
      }

      // Dots: tap to jump (mobile).
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i, true); });
      });

      if (dots.length) setActiveDot(0);

      // Keep dots in sync as the person swipes.
      if (dots.length && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                setActiveDot(slides.indexOf(entry.target));
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) { observer.observe(slide); });
      }

      // Desktop: hovering/focusing a logo jumps the track to its
      // slide. Guarded to real hover devices, so touch just uses
      // the native swipe above and never fights with tapping a
      // logo's link.
      var wantsHoverSwap = el.getAttribute('data-swap') === 'true';
      var isHoverDevice = window.matchMedia('(hover: hover)').matches;

      if (wantsHoverSwap && isHoverDevice) {
        var logos = el.querySelectorAll('[data-quote-index]');
        logos.forEach(function (logo) {
          var idx = parseInt(logo.getAttribute('data-quote-index'), 10);
          if (isNaN(idx)) return;
          logo.addEventListener('mouseenter', function () { goTo(idx, false); });
          logo.addEventListener('focusin', function () { goTo(idx, false); });
        });

        var rail = el.querySelector('.pr__logos');
        if (rail) {
          rail.addEventListener('mouseleave', function () { goTo(0, false); });
          rail.addEventListener('focusout', function (e) {
            if (!rail.contains(e.relatedTarget)) goTo(0, false);
          });
        }
      }

      window.addEventListener('resize', function () {
        var active = dots.length
          ? Array.prototype.findIndex.call(dots, function (d) { return d.classList.contains('is-active'); })
          : 0;
        goTo(active < 0 ? 0 : active, false);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-color-grid"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Horizontal Scent Spectrum

     Desktop: converts vertical scroll into horizontal travel
     inside a pinned viewport, parallaxes each print against its
     panel, and settles it as it reaches centre.

     Mobile and reduced-motion: the CSS carousel is left alone
     and this script only wires quick add.

     One rAF-throttled scroll listener. All work is skipped when
     the section is outside the viewport.
     ========================================================== */

  (function () {
    'use strict';

    var FLAG = 'hspInitialised';
    var DESKTOP = '(min-width: 990px)';
    var REDUCED = '(prefers-reduced-motion: reduce)';

    function initAll(root) {
      var scope = root || document;
      var nodes = scope.querySelectorAll('[data-scent-spectrum]');

      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset[FLAG] === 'true') continue;
        el.dataset[FLAG] = 'true';
        new Spectrum(el);
      }
    }

    function Spectrum(el) {
      this.el = el;
      this.track = el.querySelector('[data-hsp-track]');
      this.panels = toArray(el.querySelectorAll('[data-hsp-panel]'));
      this.stages = toArray(el.querySelectorAll('[data-hsp-parallax]'));
      this.prints = toArray(el.querySelectorAll('[data-hsp-print]'));
      this.railBtns = toArray(el.querySelectorAll('[data-hsp-jump]'));
      this.status = el.querySelector('[data-hsp-status]');

      this.parallax = parseFloat(el.getAttribute('data-parallax') || '20') / 100;
      this.settle = el.getAttribute('data-settle') !== 'false';
      this.focusMode = el.getAttribute('data-focus-mode') === 'true';
      this.artMode = el.getAttribute('data-art-mode') || 'scroll';
      this.artInterval = parseInt(el.getAttribute('data-art-interval'), 10) || 1600;
      this.drawerSelector = el.getAttribute('data-cart-drawer') || '';
      this.cartEvent = el.getAttribute('data-cart-event') || '';
      this.cartFallback = el.getAttribute('data-cart-fallback') || 'stay';
      this.cartSection = el.getAttribute('data-cart-section') || '';
      this.cartSections = el.getAttribute('data-cart-sections') || '';
      this.successEvent = el.getAttribute('data-cart-success') || '';
      this.currentForm = null;
      this.total = this.panels.length;
      this.active = -1;
      this.ticking = false;
      this.visible = false;
      this.pinned = false;

      this.initQuickAdd();

      this.desktopMQ = window.matchMedia(DESKTOP);
      this.reducedMQ = window.matchMedia(REDUCED);

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.frame = this.frame.bind(this);
      this.evaluate = this.evaluate.bind(this);

      this.bindRail();
      this.bindKeyboardFocus();

      addMQListener(this.desktopMQ, this.evaluate);
      addMQListener(this.reducedMQ, this.evaluate);
      this.evaluate();
    }

    /* ── pin on or off ────────────────────────────────────── */

    Spectrum.prototype.evaluate = function () {
      var shouldPin = this.desktopMQ.matches && !this.reducedMQ.matches;

      if (shouldPin && !this.pinned) {
        this.stopCarouselArt();
        this.enablePin();
      } else if (!shouldPin && this.pinned) {
        this.disablePin();
        this.startCarouselArt();
      } else if (shouldPin) {
        this.frame();
      } else {
        // Neither branch above fires on a first load at mobile
        // width, since nothing has changed yet. Without this the
        // carousel never starts its note imagery at all.
        this.startCarouselArt();
      }
    };

    Spectrum.prototype.enablePin = function () {
      this.pinned = true;
      this.el.classList.add('is-pinned');
      this.measured = false;
      if (this.focusMode) this.el.setAttribute('data-focus', 'on');

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      var self = this;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          function (entries) {
            self.visible = entries[0].isIntersecting;
            if (self.visible) self.onScroll();
          },
          { rootMargin: '100px 0px' }
        );
        this.observer.observe(this.el);
      } else {
        this.visible = true;
      }

      this.frame();
    };

    Spectrum.prototype.disablePin = function () {
      this.pinned = false;
      this.el.classList.remove('is-pinned');

      // Carousel and reduced-motion show one panel at a time, so
      // holding colour back would just look broken.
      this.el.setAttribute('data-focus', 'off');
      var self = this;
      this.panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        self.stopCycle(panel);
        self.showLayer(panel, 0);
      });
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      // Hand layout back to CSS.
      this.track.style.transform = '';
      this.stages.forEach(function (s) {
        s.style.transform = '';
      });
      this.prints.forEach(function (p) {
        p.style.transform = '';
      });
    };

    /* ── scroll loop ──────────────────────────────────────── */

    /* scrollWidth is unreliable here: browsers disagree about
       whether a flex container's trailing padding counts. Measure
       the panels and the padding directly instead, and cache it
       since it only changes on resize. */
    Spectrum.prototype.measure = function () {
      var style = window.getComputedStyle(this.track);
      var padLeft = parseFloat(style.paddingLeft) || 0;
      var padRight = parseFloat(style.paddingRight) || 0;
      var gap = parseFloat(style.columnGap || style.gap) || 0;

      var panelsWidth = 0;
      this.panels.forEach(function (panel) {
        panelsWidth += panel.offsetWidth;
      });
      if (this.total > 1) panelsWidth += gap * (this.total - 1);

      this.trackWidth = padLeft + panelsWidth + padRight;
      this.measured = true;
    };

    Spectrum.prototype.onScroll = function () {
      if (!this.ticking) {
        this.ticking = true;
        window.requestAnimationFrame(this.frame);
      }
    };

    Spectrum.prototype.onResize = function () {
      this.measured = false;
      this.onScroll();
    };

    Spectrum.prototype.frame = function () {
      this.ticking = false;
      if (!this.pinned || (this.observer && !this.visible)) return;

      var rect = this.el.getBoundingClientRect();
      var vh = window.innerHeight;
      var span = rect.height - vh;
      if (span <= 0) return;

      var progress = clamp(-rect.top / span, 0, 1);

      if (!this.measured) this.measure();

      var distance = this.trackWidth - window.innerWidth;
      if (distance < 0) distance = 0;

      this.track.style.transform =
        'translate3d(' + -(progress * distance).toFixed(2) + 'px,0,0)';

      var mid = window.innerWidth / 2;
      var self = this;

      this.panels.forEach(function (panel, i) {
        var pr = panel.getBoundingClientRect();

        // Skip panels well outside the viewport.
        if (pr.right < -200 || pr.left > window.innerWidth + 200) return;

        var offset = (pr.left + pr.width / 2 - mid) / window.innerWidth;

        if (self.stages[i] && self.parallax > 0) {
          self.stages[i].style.transform =
            'translate3d(' + (offset * pr.width * self.parallax).toFixed(2) + 'px,0,0)';
        }

        if (self.settle && self.prints[i]) {
          var nearness = Math.max(0, 1 - Math.abs(offset) * 2.6);
          self.prints[i].style.transform =
            'scale(' + (0.93 + nearness * 0.07).toFixed(4) + ')';
        }

        // Scroll mode steps through the note photographs as the
        // panel travels, so the reveal is tied to the movement
        // rather than to a clock the visitor cannot see.
        if (self.artMode === 'scroll') {
          var layers = panel.querySelectorAll('[data-hsp-layer]');
          if (layers.length > 1) {
            var travel = clamp((0.5 - offset) / 1.0, 0, 0.9999);
            self.showLayer(panel, Math.floor(travel * layers.length));
          }
        }
      });

      var index = Math.min(this.total - 1, Math.round(progress * (this.total - 1)));
      if (index !== this.active) {
        this.active = index;
        this.setActivePanel(index);
        this.updateRail(index);
      }
    };

    /* Only the centred panel wears its scent colour. */
    Spectrum.prototype.setActivePanel = function (index) {
      var self = this;

      this.panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);

        // Timed mode runs a cycle only on the panel being looked
        // at, so there are never ten timers going at once.
        if (self.artMode === 'time') {
          if (on) {
            self.startCycle(panel);
          } else {
            self.stopCycle(panel);
          }
        }
      });
    };

    /* Which of the note photographs is showing. */
    Spectrum.prototype.showLayer = function (panel, index) {
      var layers = panel.querySelectorAll('[data-hsp-layer]');
      if (!layers.length) return;

      var i = ((index % layers.length) + layers.length) % layers.length;
      if (panel._hspLayer === i) return;
      panel._hspLayer = i;

      for (var n = 0; n < layers.length; n++) {
        layers[n].classList.toggle('is-showing', n === i);
      }
    };

    Spectrum.prototype.startCycle = function (panel) {
      var self = this;
      if (panel._hspTimer) return;

      var layers = panel.querySelectorAll('[data-hsp-layer]');
      if (layers.length < 2) return;

      panel._hspTimer = window.setInterval(function () {
        self.showLayer(panel, (panel._hspLayer || 0) + 1);
      }, self.artInterval);
    };

    Spectrum.prototype.stopCycle = function (panel) {
      if (panel._hspTimer) {
        window.clearInterval(panel._hspTimer);
        panel._hspTimer = null;
      }
    };

    /* ── note imagery on the carousel ─────────────────────── */

    /* Scroll mode ties the reveal to the pinned track's travel,
       which does not exist on a swipe carousel. There the panel
       in view cycles on a timer instead, and only that panel, so
       there are never ten timers running at once. */
    Spectrum.prototype.startCarouselArt = function () {
      if (this.carouselObserver) return;
      if (this.reducedMQ.matches) return;
      if (!('IntersectionObserver' in window)) return;

      var self = this;
      var hasArt = this.panels.some(function (panel) {
        return panel.querySelectorAll('[data-hsp-layer]').length > 1;
      });
      if (!hasArt) return;

      this.carouselObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.startCycle(entry.target);
            } else {
              self.stopCycle(entry.target);
            }
          });
        },
        {
          // Measured against the track, so 'in view' means centred
          // in the carousel rather than anywhere on the page.
          root: self.track,
          threshold: 0.6
        }
      );

      this.panels.forEach(function (panel) {
        self.carouselObserver.observe(panel);
      });
    };

    Spectrum.prototype.stopCarouselArt = function () {
      if (!this.carouselObserver) return;
      this.carouselObserver.disconnect();
      this.carouselObserver = null;

      var self = this;
      this.panels.forEach(function (panel) {
        self.stopCycle(panel);
      });
    };

    Spectrum.prototype.updateRail = function (index) {
      this.railBtns.forEach(function (btn, i) {
        var on = i === index;
        btn.classList.toggle('is-active', on);
        if (on) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      });

      if (this.status) {
        var panel = this.panels[index];
        var title = panel ? panel.querySelector('.hsp__title') : null;
        if (title) this.status.textContent = title.textContent;
      }
    };

    /* ── rail jump ────────────────────────────────────────── */

    Spectrum.prototype.bindRail = function () {
      var self = this;

      this.railBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = parseInt(btn.getAttribute('data-hsp-jump'), 10) || 0;
          self.scrollToIndex(index);
        });
      });
    };

    Spectrum.prototype.scrollToIndex = function (index) {
      if (this.pinned) {
        var rect = this.el.getBoundingClientRect();
        var top = window.pageYOffset + rect.top;
        var span = rect.height - window.innerHeight;
        var ratio = this.total > 1 ? index / (this.total - 1) : 0;

        window.scrollTo({ top: top + span * ratio, behavior: 'smooth' });
      } else {
        var panel = this.panels[index];
        if (panel && panel.scrollIntoView) {
          panel.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
    };

    /* ── keyboard access ──────────────────────────────────── */

    Spectrum.prototype.bindKeyboardFocus = function () {
      var self = this;

      // Tabbing into an off-screen panel must bring it into view,
      // otherwise focus lands somewhere the user cannot see.
      this.panels.forEach(function (panel, index) {
        panel.addEventListener('focusin', function () {
          if (self.pinned && index !== self.active) {
            self.scrollToIndex(index);
          }
        });
      });
    };

    /* ── quick add ────────────────────────────────────────── */

    /* Themes expose their cart drawer in wildly different ways.
       Rather than assume Dawn's custom elements, this tries a
       ladder: the selector configured in the section, then Dawn's
       elements, then a battery of events most themes listen for.
       Only if the add itself fails do we fall back to /cart. */
    Spectrum.prototype.findDrawer = function () {
      if (this.drawerSelector) {
        var configured = document.querySelector(this.drawerSelector);
        if (configured) return configured;
      }

      var known = [
        'cart-drawer',
        'cart-notification',
        '#CartDrawer',
        '#cart-drawer',
        '[data-cart-drawer]',
        '.cart-drawer',
        '.js-cart-drawer'
      ];

      for (var i = 0; i < known.length; i++) {
        var el = document.querySelector(known[i]);
        if (el) return el;
      }

      return null;
    };

    /* Ask the theme to refresh and open, whatever it is. */
    Spectrum.prototype.notifyCart = function (cartData, drawer) {
      // Refreshing and opening are two separate jobs and every
      // step below is about opening. This one only updates the
      // data, so it must not short circuit the rest.
      //
      // Baseline keeps its cart in an Alpine component and calls
      // onCartQuantityChange after every add. The drawer renders
      // from that state rather than from the server, so swapping
      // HTML or firing events changes nothing on its own.
      var refreshed = this.dispatchThemeCart(cartData);
      var opened = this.dispatchAddSuccess(this.currentForm);

      // Both handled by the theme, so the ladder below is not
      // needed and would only fire duplicate events.
      if (refreshed && opened) return true;

      // 1. Dawn and its derivatives render sections directly.
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(cartData);
        if (drawer.classList.contains('is-empty')) {
          drawer.classList.remove('is-empty');
        }
        if (typeof drawer.open === 'function') drawer.open();
        return true;
      }

      // 2. For themes that render the drawer server side, ask
      //    for fresh markup. Skipped when the component above
      //    already handled it, so the two cannot fight.
      if (!refreshed) this.refreshDrawer(drawer);

      // 3. An explicit event name set in the section settings.
      if (this.cartEvent) {
        document.dispatchEvent(
          new CustomEvent(this.cartEvent, { bubbles: true, detail: cartData })
        );
      }

      // 4. The events themes commonly listen for. Harmless when
      //    nothing is bound to them.
      var events = [
        'cart:refresh',
        'cart:update',
        'cart:updated',
        'cart:build',
        'cart:open',
        'ajaxProduct:added',
        'product:added'
      ];

      for (var i = 0; i < events.length; i++) {
        document.dispatchEvent(
          new CustomEvent(events[i], { bubbles: true, detail: cartData })
        );
      }

      // 5. Some themes only open on a click of their own toggle.
      var toggle = document.querySelector(
        '[data-cart-drawer-toggle], [data-drawer-open="cart"], .js-drawer-open-cart'
      );
      if (toggle) {
        toggle.click();
        return true;
      }

      return refreshed || !!this.cartEvent;
    };

    /* Hands the theme its own cart event.

       Baseline's CartItems component listens on window for
       baseline:cart:afteradditem and baseline:cart:cartqtychange,
       and reads pre-rendered section HTML straight off the
       event:

         e.detail.response.sections['cart-items']

       So the add request has to ask for those sections, and the
       event has to carry them. Calling the component's method
       directly cannot work: with no event to read, it throws on
       the first line. */
    Spectrum.prototype.dispatchThemeCart = function (data) {
      if (!data || !data.sections) return false;

      var names = (this.cartEvent || 'baseline:cart:afteradditem')
        .split(',')
        .map(function (n) {
          return n.trim();
        })
        .filter(Boolean);

      // Dispatched on body because that is where the theme
      // raises it itself, and it bubbles to the window listener.
      for (var i = 0; i < names.length; i++) {
        document.body.dispatchEvent(
          new CustomEvent(names[i], {
            bubbles: true,
            detail: { response: data, originalTarget: null }
          })
        );
      }

      return true;
    };

    /* The theme raises a second event from the form itself after
       a successful add. That one is what opens the drawer, so
       both are needed: the cart event updates the contents, this
       one reveals them. */
    Spectrum.prototype.dispatchAddSuccess = function (form) {
      if (!this.successEvent) return false;

      (form || document.body).dispatchEvent(
        new CustomEvent(this.successEvent, { bubbles: true })
      );

      return true;
    };

    /* Swaps the drawer's markup for a freshly rendered copy.
       The section id comes from the setting, or from the
       wrapper Shopify puts around every section. */
    Spectrum.prototype.refreshDrawer = function (drawer) {
      var id = this.cartSection;

      if (!id && drawer) {
        var wrapper = drawer.id && drawer.id.indexOf('shopify-section-') === 0
          ? drawer
          : drawer.closest('[id^="shopify-section-"]');
        if (wrapper) id = wrapper.id.replace('shopify-section-', '');
      }

      if (!id) return;

      var root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + '?section_id=' + encodeURIComponent(id), {
        headers: { Accept: 'text/html' }
      })
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          if (!html) return;

          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.getElementById('shopify-section-' + id) || parsed.body.firstElementChild;
          var current = document.getElementById('shopify-section-' + id);
          if (!fresh || !current) return;

          // innerHTML rather than replacing the element itself,
          // so anything bound to the wrapper survives and
          // frameworks that watch the DOM pick the new nodes up.
          current.innerHTML = fresh.innerHTML;

          document.dispatchEvent(
            new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: id }
            })
          );
        })
        .catch(function () {
          // The events below still get their chance.
        });
    };

    Spectrum.prototype.initQuickAdd = function () {
      var self = this;
      var forms = this.el.querySelectorAll('form.hsp__form');

      toArray(forms).forEach(function (form) {
        form.addEventListener('submit', function (event) {
          if (!window.fetch) return; // let the native POST happen

          event.preventDefault();

          var button = form.querySelector('[data-hsp-add]');
          var label = button ? button.querySelector('.hsp__add-label') : null;
          var original = label ? label.textContent : '';

          if (button) {
            button.setAttribute('aria-busy', 'true');
            if (label) label.textContent = 'Adding…';
          }

          self.currentForm = form;

          var drawer = self.findDrawer();
          var body = new FormData(form);

          // Ask for the section HTML the theme needs. Without
          // this the response has no sections and the theme's
          // handler throws reading them off the event.
          if (self.cartSections) {
            body.append('sections', self.cartSections);
            body.append('sections_url', window.location.pathname);
          } else if (drawer && typeof drawer.getSectionsToRender === 'function') {
            body.append(
              'sections',
              drawer
                .getSectionsToRender()
                .map(function (s) {
                  return s.id;
                })
                .join(',')
            );
            body.append('sections_url', window.location.pathname);
          }

          var root =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          // Matches the theme's own request. X-Requested-With is
          // what it sends, and Content-Type is deliberately left
          // off so the browser sets the multipart boundary.
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: body
          })
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              if (data.status) {
                // Sold out, limit reached, etc.
                if (label) label.textContent = 'Unavailable';
                setTimeout(function () {
                  if (label) label.textContent = original;
                }, 2200);
                return;
              }

              var handled = self.notifyCart(data, drawer);

              if (label) label.textContent = 'Added';
              setTimeout(function () {
                if (label) label.textContent = original;
              }, 1800);

              // Reload is unconditional: the drawer may well have
              // opened, just without the new item in it, which is
              // the failure this covers.
              if (self.cartFallback === 'reload') {
                window.location.reload();
                return;
              }

              // Nothing in the theme responded, so at least take
              // the visitor somewhere the item is visible.
              if (!handled && self.cartFallback === 'redirect') {
                window.location = root + 'cart';
              }
            })
            .catch(function () {
              form.submit();
            })
            .finally(function () {
              if (button) button.removeAttribute('aria-busy');
            });
        });
      });
    };

    /* ── helpers ──────────────────────────────────────────── */

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function addMQListener(mq, fn) {
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', fn);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(fn);
      }
    }

    /* ── boot ─────────────────────────────────────────────── */

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Colophon ticker

     Scroll mode: duration is computed from the measured track
     width so the pace stays constant no matter how many phrases
     there are, and the group is repeated until each half is at
     least a viewport wide, otherwise a short list leaves a gap.

     Rotate mode: a simple crossfade between phrases.
     ========================================================== */

  (function () {
    'use strict';

    var FLAG = 'tickerInit';

    function init(root) {
      var scope = root || document;
      var nodes = scope.querySelectorAll('[data-ticker]');

      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.dataset[FLAG] === 'true') continue;
        el.dataset[FLAG] = 'true';

        if (el.getAttribute('data-mode') === 'rotate') {
          rotate(el);
        } else {
          scroll(el);
        }
      }
    }

    /* ── scroll ───────────────────────────────────────────── */

    function scroll(el) {
      var track = el.querySelector('[data-tick-track]');
      if (!track) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var speed = parseFloat(el.getAttribute('data-speed')) || 45;
      var filled = false;

      function measure() {
        var groups = track.querySelectorAll('[data-tick-group]');
        if (!groups.length) return;

        // Each half must be at least a viewport wide or the loop
        // shows empty space before it repeats.
        if (!filled) {
          var one = groups[0].offsetWidth;
          if (one > 0) {
            var needed = Math.ceil(window.innerWidth / one);
            if (needed > 1) {
              for (var h = 0; h < groups.length; h++) {
                for (var n = 1; n < needed; n++) {
                  var copy = groups[h].cloneNode(true);
                  copy.setAttribute('aria-hidden', 'true');
                  groups[h].parentNode.insertBefore(copy, groups[h].nextSibling);
                }
              }
            }
            filled = true;
          }
        }

        var half = track.scrollWidth / 2;
        if (half > 0) {
          track.style.setProperty('--tick-duration', half / speed + 's');
        }
      }

      measure();

      // Webfonts change the width after first paint.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measure);
      }

      var t = null;
      window.addEventListener('resize', function () {
        window.clearTimeout(t);
        t = window.setTimeout(measure, 200);
      });
    }

    /* ── rotate ───────────────────────────────────────────── */

    function rotate(el) {
      var phrases = el.querySelectorAll('[data-tick-phrase]');
      if (phrases.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var interval = (parseInt(el.getAttribute('data-interval'), 10) || 4) * 1000;
      var pause = el.getAttribute('data-pause') === 'true';
      var i = 0;
      var timer = null;

      function show(n) {
        i = ((n % phrases.length) + phrases.length) % phrases.length;
        for (var k = 0; k < phrases.length; k++) {
          var on = k === i;
          phrases[k].classList.toggle('is-active', on);
          if (on) {
            phrases[k].removeAttribute('aria-hidden');
          } else {
            phrases[k].setAttribute('aria-hidden', 'true');
          }
        }
      }

      function start() {
        if (timer) return;
        timer = window.setInterval(function () { show(i + 1); }, interval);
      }

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      start();

      if (pause) {
        el.addEventListener('mouseenter', stop);
        el.addEventListener('mouseleave', start);
        el.addEventListener('focusin', stop);
        el.addEventListener('focusout', start);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-step"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================
     Two step signup

     Posts to Klaviyo's client subscription endpoint. Step one
     sends the email with email marketing consent; step two
     sends the phone with SMS marketing consent and the same
     email, so Klaviyo matches the profile just created rather
     than making a second.
     ========================================================== */

  (function () {
    'use strict';

    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var REVISION = '2026-07-15';
    var FLAG = 'tsInit';

    function init(root) {
      var forms = (root || document).querySelectorAll('[data-ts-form]');

      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        if (form.dataset[FLAG] === 'true') continue;
        form.dataset[FLAG] = 'true';
        bind(form);
      }
    }

    /* Klaviyo needs E.164, so a typed number is normalised before
       sending. Anything already starting with + is left alone. */
    function toE164(raw, country) {
      var value = (raw || '').trim();
      if (value.charAt(0) === '+') return '+' + value.replace(/\D/g, '');

      var digits = value.replace(/\D/g, '');
      if (!digits) return '';

      var cc = (country || '+1').replace(/\D/g, '');
      if (digits.length > 10 && digits.indexOf(cc) === 0) return '+' + digits;
      return '+' + cc + digits;
    }

    function subscribe(key, list, attributes) {
      return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: attributes } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      });
    }

    function bind(form) {
      var section = form.closest('.ts');
      if (!section) return;

      var key = form.getAttribute('data-key');
      var list = form.getAttribute('data-list');
      var smsList = form.getAttribute('data-sms-list') || list;
      var country = form.getAttribute('data-country') || '+1';

      var email = form.querySelector('[data-ts-email]');
      var emailBtn = form.querySelector('[data-ts-email-submit]');
      var emailMsg = form.querySelector('[data-ts-email-message]');

      var panel1 = section.querySelector('[data-ts-panel-1]');
      var step2 = section.querySelector('[data-ts-step2]');
      var done = section.querySelector('[data-ts-done]');
      var doneBody = section.querySelector('[data-ts-done-body]');
      var confirmEmail = section.querySelector('[data-ts-confirm-email]');
      var phone = section.querySelector('[data-ts-phone]');
      var phoneBtn = section.querySelector('[data-ts-phone-submit]');
      var phoneMsg = section.querySelector('[data-ts-phone-message]');
      var skip = section.querySelector('[data-ts-skip]');

      function say(node, text, ok) {
        if (!node) return;
        node.textContent = text;
        node.hidden = false;
        node.classList.toggle('ts__note--error', !ok);
      }

      var text = {
        emailOk: form.getAttribute('data-email-success'),
        smsOk: form.getAttribute('data-sms-success'),
        badEmail: form.getAttribute('data-invalid-email'),
        badPhone: form.getAttribute('data-invalid-phone'),
        error: form.getAttribute('data-error'),
        sending: form.getAttribute('data-sending')
      };

      var savedEmail = '';

      /* One panel at a time, in the same place. The height
         settles before the new panel fades in, so the page does
         not jump under the pointer. */
      function show(next) {
        [panel1, step2, done].forEach(function (panel) {
          if (panel && panel !== next) panel.hidden = true;
        });
        if (!next) return;
        next.hidden = false;
        next.classList.remove('is-entering');
        // Reflow, so the class re-triggers the transition.
        void next.offsetWidth;
        next.classList.add('is-entering');
      }

      /* ── step one ─────────────────────────────────────────── */

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var value = (email.value || '').trim();
        if (!value || value.indexOf('@') < 1 || value.indexOf('.') < 0) {
          say(emailMsg, text.badEmail, false);
          email.focus();
          return;
        }

        emailBtn.disabled = true;
        say(emailMsg, text.sending, true);

        subscribe(key, list, {
          email: value,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        })
          .then(function (r) {
            // 202 is accepted and processed afterwards, which is
            // as final an answer as this endpoint gives.
            if (r.status === 202 || r.ok) {
              savedEmail = value;

              if (confirmEmail) confirmEmail.textContent = value;

              if (step2) {
                show(step2);
                // Moving focus is what makes the second step read
                // as a continuation rather than a new thing.
                if (phone) phone.focus();
              } else {
                say(emailMsg, text.emailOk, true);
                email.disabled = true;
              }
              return;
            }
            say(emailMsg, text.error, false);
            emailBtn.disabled = false;
          })
          .catch(function () {
            say(emailMsg, text.error, false);
            emailBtn.disabled = false;
          });
      });

      /* ── step two ─────────────────────────────────────────── */

      if (skip && step2) {
        skip.addEventListener('click', function () {
          if (doneBody) doneBody.textContent = text.emailOk;
          show(done);
        });
      }

      if (phone && phoneBtn) {
        phoneBtn.addEventListener('click', function () {
          var e164 = toE164(phone.value, country);

          if (e164.length < 11) {
            say(phoneMsg, text.badPhone, false);
            phone.focus();
            return;
          }

          phoneBtn.disabled = true;
          say(phoneMsg, text.sending, true);

          subscribe(key, smsList, {
            // The email ties this to the profile made a moment
            // ago rather than creating a second one.
            email: savedEmail,
            phone_number: e164,
            subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
          })
            .then(function (r) {
              if (r.status === 202 || r.ok) {
                if (doneBody) doneBody.textContent = text.smsOk;
                show(done);
                return;
              }
              say(phoneMsg, text.error, false);
              phoneBtn.disabled = false;
            })
            .catch(function () {
              say(phoneMsg, text.error, false);
              phoneBtn.disabled = false;
            });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
